import Cookies from '../../node_modules/js-cookie';

const winAny = (window as any);
winAny.appPopupMessage3 ??= {};
winAny.appPopupMessage3.init ??= init;
winAny.appPopupMessage3.popUpShown = false; // parameter to prevent more than 1 popups showing simultaniously

function showModal(modal: HTMLElement) {
    modal.setAttribute('aria-hidden', 'false');
    modal.classList.add('is-open');
    document.body.classList.add('modal-open');
}

function setSeenCookie(domId: string, showAgainAfter?: string) {
    const cookieName = `seenpopup-${domId}`;
    if (Cookies.get(cookieName)) return; // schon gesetzt, nicht überschreiben

    const expires = parseFloat(showAgainAfter ?? '');

    if (!Number.isNaN(expires)) {
        const expiresInMinutes = expires * 24 * 60;
        console.log(`Setting cookie ${cookieName} with expires in ${expiresInMinutes} minutes`);
        Cookies.set(cookieName, true, { expires });
    } else {
        console.log(`Setting cookie ${cookieName} with default expiration (session cookie)`);
        Cookies.set(cookieName, true);
    }
}

function closeModal(modal: HTMLElement) {
    modal.setAttribute('aria-hidden', 'true');
    modal.classList.remove('is-open');
    document.body.classList.remove('modal-open');

    // Cookie erst beim Schliessen setzen
    const domId = modal.id;
    const showAgainAfter = modal.dataset.popupMessage3ShowAgainAfter;
    if (domId) {
        setSeenCookie(domId, showAgainAfter);
    }
}

function wireModalEvents(modal: HTMLElement, domId: string) {
    if (modal.dataset.popupMessage3Wired === 'true') return;
    modal.dataset.popupMessage3Wired = 'true';

    modal.addEventListener('click', (event) => {
        const target = event.target as HTMLElement | null;
        if (target?.closest('[data-micromodal-close]')) {
            closeModal(modal);
        }
    });

    document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && modal.classList.contains('is-open')) {
            closeModal(modal);
        }
    });

    document.querySelectorAll(`[data-micromodal-trigger="${domId}"]`).forEach((trigger) => {
        trigger.addEventListener('click', (event) => {
            event.preventDefault();
            showModal(modal);
        });
    });
}

function init(options?: { domId?: string, showAgainAfter?: string }) {
    const domId = options?.domId?.trim();
    const showAgainAfter = options?.showAgainAfter;
    if (!domId) return;

    const modal = document.getElementById(domId);
    if (!modal) return;

    // showAgainAfter am Modal ablegen, damit closeModal() später darauf zugreifen kann
    if (showAgainAfter !== undefined) {
        modal.dataset.popupMessage3ShowAgainAfter = showAgainAfter;
    }

    wireModalEvents(modal, domId);

    if (!Cookies.get(`seenpopup-${domId}`) && winAny.appPopupMessage3.popUpShown === false && !document.body.classList.contains('role-admin')) {
        winAny.appPopupMessage3.popUpShown = true;
        setTimeout(() => {
            showModal(modal);
        }, 2000);
    }
}